import React from "react";

export default function ErrorPage() {
  return <div>404</div>;
}
